import { render } from "./UclWeeklyResult.vue?vue&type=template&id=92fe023a"
import script from "./UclWeeklyResult.vue?vue&type=script&lang=js"
export * from "./UclWeeklyResult.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__